import React,{useState,useEffect} from 'react';
import Navber from '../Components/Navber';
import { NavLink, Routes, Route,Outlet } from 'react-router-dom';
import api from "../Api.js"
import "../Styles/Profile.css";
import { FaUserEdit, FaHotel, FaHiking, FaCogs, FaSignOutAlt, FaMapMarkedAlt, FaFantasyFlightGames, FaPlane,FaBus ,FaRing} from "react-icons/fa";


function Profile() {
          const customer = JSON.parse(localStorage.getItem("customer"));
    console.log("customer", customer);
  
    const [franchise,setFranchise]= useState(null)
const token = localStorage.getItem("accessToken");
console.log(token)

useEffect(() => {
  const fetchHandleProfile = async () => {
    try {
      if (!token) return; // ✅ prevent API call without token

      const response = await api.get("/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Franchise response:", response?.data);
      setFranchise(response?.data?.customer?.is_franchise);
      localStorage.setItem("franchise_customer", JSON.stringify(response.data.customer));

    } catch (error) {
      console.error("Profile fetch error:", error);

      // Optional: auto logout if token expired
      if (error.response?.status === 401) {
        localStorage.removeItem("accessToken"); 
        localStorage.removeItem("customer");
        window.location.href = "/";
      }
    }
  };

  fetchHandleProfile();

}, [token]);


  return (
    <div>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      <div className="profilePage_container">
        {/* Sidebar */}
<div className="profilePage_sidebar">
  <NavLink 
    to="/profile" 
    end
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaUserEdit className="profilePage_icon" />Profile
  </NavLink>

  <NavLink 
    to="/profile/tour-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaMapMarkedAlt className="profilePage_icon" /> Tours
  </NavLink>

  <NavLink 
    to="/profile/hotel-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaHotel className="profilePage_icon" /> Hotel
  </NavLink>

  <NavLink 
    to="/profile/activity-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaHiking className="profilePage_icon" /> Activity
  </NavLink>
  <NavLink 
    to="/profile/destination-wedding" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaRing className="profilePage_icon" />Wedding
  </NavLink>
  <NavLink 
    to="/profile/honeymoon" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaRing className="profilePage_icon" />Honeymoon
  </NavLink>
  <NavLink 
    to="/profile/cab" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaRing className="profilePage_icon" />Cab
  </NavLink>
  
  {/* <NavLink 
    to="/profile/flight-info" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaPlane className="profilePage_icon" /> Flight
  </NavLink>
    <NavLink 
  to="/profile/Bus-info" 
  className={({ isActive }) => 
    isActive ? "profilePage_link active" : "profilePage_link"
  }
>
  <FaBus className="profilePage_icon" /> Bus
</NavLink> */}


 {franchise === true ? (
  <NavLink 
    to="/profile/franchise" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaUserEdit className="profilePage_icon" /> Franchise
  </NavLink>
) : null}

  <NavLink 
    to="/profile/settings" 
    className={({ isActive }) => 
      isActive ? "profilePage_link active" : "profilePage_link"
    }
  >
    <FaCogs className="profilePage_icon" /> Settings
  </NavLink>

  <NavLink 
    to="/profile/logout" 
    className={({ isActive }) => 
      isActive ? "profilePage_link logout active" : "profilePage_link logout"
    }
  >
    <FaSignOutAlt className="profilePage_icon" /> Logout
  </NavLink>
</div>


        {/* Right-side Content */}
        <div className="profilePage_content">
            <Outlet/>
        </div>
      </div>
    </div>
  );
}

export default Profile;
